import Bind from "lodash-decorators/bind";
import React, { PureComponent } from "react";
import { CSSTransition } from "react-transition-group";
import styled from "../../theme/index";

const TooltipBox = styled.span`
    position: relative;
    cursor: pointer;

    .tooltip {
        position: relative;
    }

    .tooltip-message {
        background: rgba(0, 0, 0, 0.7);
        border-radius: 3px;
        color: #fff;
        font-size: 0.75rem;
        line-height: 1.4;
        padding: 0.75em;
        text-align: center;
    }

    .tooltip-message-box-enter {
      opacity: 0;
      transform: scale(0.9);
    }

    .tooltip-message-box-enter-active {
      opacity: 1;
      transform: translateX(0);
      transition: opacity 300ms, transform 300ms;
    }

    .tooltip-message-box-exit {
      opacity: 1;
    }

    .tooltip-message-box-exit-active {
      opacity: 0;
      transform: scale(0.9);
      transition: opacity 300ms, transform 300ms;
    }

    .tooltip-bubble {
        min-width: 120px;
        max-width: 210px;
        position: absolute;
        z-index: 10;

        &::after {
            content: '';
            position: absolute;
        }
    }

    .tooltip-top {
        bottom: 100%;
        left: 50%;
        padding-bottom: 9px;
        transform: translateX(-50%);

        &::after {
            border-left: 9px solid transparent;
            border-right: 9px solid transparent;
            border-top: 9px solid rgba(0, 0, 0, 0.7);
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .tooltip-bottom {
        top: 100%;
        left: 50%;
        padding-top: 9px;
        transform: translateX(-50%);

        &::after {
            border-left: 9px solid transparent;
            border-right: 9px solid transparent;
            border-bottom: 9px solid rgba(0, 0, 0, 0.7);
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .tooltip-left {
        top: 50%;
        right: 100%;
        padding-right: 9px;
        transform: translateY(-50%);

        &::after {
            border-left: 9px solid rgba(0, 0, 0, 0.7);
            border-top: 9px solid transparent;
            border-bottom: 9px solid transparent;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
        }
    }

    .tooltip-right {
        top: 50%;
        left: 100%;
        padding-left: 9px;
        transform: translateY(-50%);

        &::after {
            border-right: 9px solid rgba(0, 0, 0, 0.7);
            border-top: 9px solid transparent;
            border-bottom: 9px solid transparent;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
    }
`;

interface State {
    displayTooltip: boolean;
}

interface CopyToClipboardProps {
    message: React.ReactNode;
    position: string;
    children?: React.ReactNode;
}

export class Tooltip extends PureComponent<CopyToClipboardProps, State> {
    public state: State = {
        displayTooltip: false,
    };

    public render(): JSX.Element {
        return (
            <TooltipBox>
                <span className="tooltip" onMouseLeave={this.hideTooltip}>
                    <CSSTransition
                        in={this.state.displayTooltip}
                        timeout={300}
                        classNames="tooltip-message-box"
                        unmountOnExit
                    >
                        <div className={`tooltip-bubble tooltip-${this.props.position}`}>
                            <div className="tooltip-message">{this.props.message}</div>
                        </div>
                    </CSSTransition>

                    <span className="tooltip-trigger" onMouseOver={this.showTooltip}>
                        {this.props.children}
                    </span>
                </span>
            </TooltipBox>
        );
    }

    @Bind()
    public hideTooltip(): void {
        this.setState({displayTooltip: false});
    }

    @Bind()
    public showTooltip(): void {
        this.setState({displayTooltip: true});
    }
}

export default Tooltip;
